export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "lorem": {
    "title": "Lorem Ipsum Generator",
    "subtitle": "Generate placeholder text for design, development, and content mockups. ",
    "privacy": "100% client-side",
    "style": "Text Style",
    "styleLatin": "Latin",
    "styleChinese": "Chinese",
    "styleBusiness": "Business",
    "styleTech": "Tech",
    "paragraphs": "Paragraphs",
    "sentences": "Sentences / Paragraph",
    "startWithLorem": "Start with Lorem Ipsum",
    "wrapHtml": "Wrap in HTML <p>",
    "generate": "Generate",
    "statWords": "Words",
    "statChars": "Characters",
    "statSentences": "Sentences",
    "statParagraphs": "Paragraphs",
    "emptyHint": "Configure settings above and click Generate to create placeholder text"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All text generation happens locally in your browser. No data is uploaded to any server."
    },
    "guide": {
      "title": "How to Use Lorem Ipsum Generator",
      "description": "Generate placeholder text for design, development, and content mockups.",
      "steps": [
        {
          "title": "Configure settings",
          "description": "Choose the number of paragraphs, sentences per paragraph, and word style. Options include standard Lorem Ipsum, English words, or custom vocabulary."
        },
        {
          "title": "Generate text",
          "description": "Click the generate button to create your placeholder text instantly. The output is formatted with proper paragraph breaks."
        },
        {
          "title": "Copy or download",
          "description": "Copy the generated text to your clipboard, or download it as a .txt or .html file for use in design tools, CMS platforms, or code editors."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Customizable paragraph and sentence count",
        "Multiple vocabulary modes: Latin, English, custom",
        "HTML and plain text output formats",
        "One-click copy and file download",
        "Real-time generation with zero latency",
        "100% client-side processing — zero data upload"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Is my data sent to a server?",
          "answer": "No. All text generation happens entirely within your browser. No content is transmitted or stored externally."
        },
        {
          "question": "What is Lorem Ipsum?",
          "answer": "Lorem Ipsum is a classic placeholder text used in publishing and design since the 1500s. It mimics natural language patterns without distracting readers with meaningful content."
        },
        {
          "question": "Can I use generated text in commercial projects?",
          "answer": "Yes. Generated placeholder text is free to use in any project, commercial or personal. Replace it with real content before publishing your final product."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Case Converter",
          "url": "/text/case-converter",
          "description": "Convert text between uppercase, lowercase, camelCase, snake_case, and more."
        },
        {
          "name": "Markdown Editor",
          "url": "/text/markdown-editor",
          "description": "Write and preview Markdown in real-time with syntax highlighting."
        },
        {
          "name": "Password Generator",
          "url": "/generator/password-generator",
          "description": "Generate strong, secure passwords and memorable passphrases."
        }
      ]
    }
  }
};
